<template>
  <custom-dialog width="50%" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body" style="padding-top: 0">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- 操作项 -->
          <el-form-item>
            <div class="name">{{ $t('dms_bind_select_dialog.zhan_dian') }}：{{ model.data.siteName }}</div>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('dms_bind_select_dialog.ji_shen_haoModemSN')" @fetch="getTableList()"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table type="checkbox" v-model="selectList" :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange"></custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" :disabled="!isSubmit" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      tableCode: 'siteSelectDevice',
      tableList: [],
      totalRows: 0,

      selectList: [],
      formSearch: {
        pageSize: 50,
        pageNum: 1,
        siteId: '',
        search: '',
      },
    };
  },
  computed: {
    isSubmit: vm => vm.selectList && vm.selectList.length,
  },
  mounted() {
    this.getTableColumn();
    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.formSearch.siteId = this.model.data.siteId;
      this.$getJSON(apis.SiteUnAssList, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 确认保存
    confirm: function () {
      const modemSn = this.selectList.map(t => t.modemSn);
      this.$postJSON(apis.SiteAssBind, {
        siteId: this.model.data.siteId,
        modemSn,
      }).then(() => {
        this.$emit('success');
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss"></style>
